import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
  Icon,
} from "../../components/Component";
import PhoneSearchStep from "./components/PhoneSearchStep";
import LeadSummary from "./components/LeadSummary";
import ReassignLeadForm from "./components/ReassignLeadForm";
import NewLeadWizard from "./components/NewLeadWizard";
import AddLeadStepOne from "./components/AddLeadStepOne";
import { useSelector } from "react-redux";
import { newRoles } from "../../utils/envConfig";

const CreateLead = () => {
  const authuser = useSelector((state) => state?.user?.loggedInUser);
  const isAllowedToSearch = authuser?.role && [newRoles.Admin, newRoles.MasterAdmin].includes(authuser?.role);

  const [useNewFlow, setUseNewFlow] = useState(false);
  const [currentStep, setCurrentStep] = useState('phone-search');
  const [foundUser, setFoundUser] = useState(null);
  const [phone, setPhone] = useState('');

  const handleUserFound = (user, phoneNumber) => {
    setFoundUser(user);
    setPhone(phoneNumber);
    setCurrentStep('lead-summary');
  };

  const handleUserNotFound = (phoneNumber) => {
    setPhone(phoneNumber);
    setCurrentStep('new-lead');
  };

  const handleReassign = () => {
    setCurrentStep('reassign');
  };

  const handleBackToSearch = () => {
    setCurrentStep('phone-search');
    setFoundUser(null);
    setPhone('');
  };

  const handleBack = () => {
    if (currentStep === 'reassign') {
      setCurrentStep('lead-summary');
    } else if (currentStep === 'new-lead') {
      setCurrentStep('phone-search');
      setFoundUser(null);
      setPhone('');
    } else {
      setCurrentStep('phone-search');
      setFoundUser(null);
      setPhone('');
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 'phone-search':
        return (
          <PhoneSearchStep
            onUserFound={handleUserFound}
            onUserNotFound={handleUserNotFound}
          />
        );
      case 'lead-summary':
        return (
          <LeadSummary
            user={foundUser}
            phone={phone}
            onReassign={handleReassign}
            onBackToSearch={handleBackToSearch}
          />
        );
      case 'reassign':
        return (
          <ReassignLeadForm
            user={foundUser}
            phone={phone}
            onBack={handleBack}
          />
        );
      case 'new-lead':
        return (
          <NewLeadWizard
            phone={phone}
            onBack={handleBack}
          />
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>

      <Head title="Add New Lead"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page className="mt-4">
                Add New Lead
              </BlockTitle>

            </BlockHeadContent>
            {isAllowedToSearch ? <BlockHeadContent>
              <div>
                <Button
                  color={useNewFlow ? 'primary' : 'light'}
                  size="sm"
                  onClick={() => setUseNewFlow(true)}
                  className="me-2"
                >
                  <Icon name="search" className="me-1" />
                  Phone Search
                </Button>
                <Button
                  color={!useNewFlow ? 'primary' : 'light'}
                  size="sm"
                  onClick={() => setUseNewFlow(false)}
                >
                  <Icon name="edit" className="me-1" />
                  Direct Form
                </Button>
              </div>
            </BlockHeadContent> : null}
          </BlockBetween>
        </BlockHead>
        <Block>

          <PreviewCard>




            {useNewFlow ? renderCurrentStep() : <AddLeadStepOne />}
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default CreateLead;
